// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3104 ? "3975359d" : chunkId) + "." + {"3104":"18e8deb5db3386ea","6777":"4901b7d510887f96","7111":"7a4c56e9c4cf1265"}[chunkId] + ".js";
};